import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RouterOutletComponent } from '@abp/ng.core';
import { NotificationMainComponent } from './notification-main/notification-main.component';

const routes: Routes = [
  {
    path: '',
     component: RouterOutletComponent,
    children: [
      {
        path: '',
        component: NotificationMainComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationRoutingModule {}
